import { CommonSettings } from './common-settings';

export class CommonDevelopmentSettings extends CommonSettings {
	constructor() {
		super();

		this.services.techBanners.buildVersion.checkInterval = 60000; // 1 minute
		this.services.utilities.userActive.awayDelay = 60 * 2 * 1000; // 2 minutes

		this.services.websocket.connectionTimeout = 5 * 1000; // 5 seconds
		this.services.websocket.connectionKeepAlive = 10 * 1000; // 10 seconds
		this.services.websocket.connectionKeepAlivePresence = 2 * 60 * 1000; // 2 minutes
	}
}
